import {ChangeDetectionStrategy, Component, inject, input, OnInit, signal} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {CdkDrag, CdkDragPreview, CdkDropList} from '@angular/cdk/drag-drop';
import {ResearchKeywordDTO} from '../../../dto/research-keywords';
import {SearchQueryKeywordComponent} from '../search-query-keyword/search-query-keyword.component';
import {QueryBlockItem} from '../../../models/query-block';
import {QueryHelperService} from '../../../helper/query-helper.service';

@Component({
  selector: 'app-search-keyword-list',
  imports: [
    MatCardModule,
    CdkDropList,
    SearchQueryKeywordComponent,
    CdkDrag,
    CdkDragPreview
  ],
  templateUrl: './search-keyword-list.component.html',
  styleUrl: './search-keyword-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchKeywordListComponent implements OnInit {
  private readonly queryHelperService: QueryHelperService = inject(QueryHelperService);
  keywords = input.required<ResearchKeywordDTO[]>();
  allDropListsIds = input<string[]>([]);

  keywordItems = signal<QueryBlockItem[]>([]);

  ngOnInit() {
    this.keywordItems.set(this.getDragData());
  }

  setDragStarted(started: boolean): void {
    this.queryHelperService.setDragStarted(started);
  }

  getDragData(): QueryBlockItem[] {
    return this.keywords().map((keyword: ResearchKeywordDTO) => {
      return new QueryBlockItem({
        keyword: keyword,
        children: []
      });
    });
  }
}
